import { Bell } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { useSignIn } from '@features/sign-in/SignInProvider';
import { useGetNotificationsQuery } from '@entities/notification/notificationApi';
import styles from './Notifications.module.css';
export function NotificationBell() {
 const {authenticated}=useSignIn();
 const {data}=useGetNotificationsQuery({}, {skip:!authenticated,pollingInterval:30000,skipPollingIfUnfocused:true,refetchOnFocus:true});
 const count=data?.unreadCount??0;
 return <Link className={styles.bell} to="/notifications" aria-label={`Notifications${count?`, ${count} unread`:''}`} title="Notifications"><Bell size={21}/>{count>0&&<span className={styles.badge} aria-hidden>{count>99?'99+':count}</span>}</Link>;
}
